import React from 'react';
import './payment.less';
import DashBoardHeader from '../header_dashboard/dashboard_header';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import authActions from '../auth/auth_actions';
import LogoutPopUp from '../components/logoutPopUp/logout_pop_up';
import cookies from '../util/cookie';
import InputComponent from '../components/input_component/input_component';
import RadioButton from '../components/radio_button/radio_button';
import LoggedinFooter from '../footer/loggedin_footer';
import CONSTANTS from '../common_constants';
import {toTitleCase,join,localTimestampToGMT,GMTTimeStampToLocal} from '../util/common';
import ShowError from '../components/error/show_error';
import NumberFormat from 'react-number-format';
import paymentActions from './payment_actions';
import '../components/radio_button/radio_button.less';
import $ from 'jquery';
import {Link, browserHistory} from 'react-router';
import requestAnItemActions from '../request_an_item/request_an_item_actions';
import validate from '../util/validate';
import browsePackagesAction from '../browse_packages/browser_packages_actions';
import moment from 'moment';

class PostAShipmentWidget extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const shipmentData = this.props.shipmentData || {};
    let imageUrl,shipmentName = "",city = "",deliveryLocation = "",priceOffered = 0,shippingCost =0,total =0;
    let discount = 0 ,actualDiscount=0;
    let priceTitle ;
    if(this.props.for == 1)
      priceTitle = "Item Value"
    else if(this.props.for == 2)
      priceTitle = "PRICE OFFERED"
    let defaultImgUrl = "../../public/images/requester_flow/placeholder.png"
    if(shipmentData.discount){
      if(shipmentData.promoCode == "Referral")
      {
        discount = (shipmentData.percentageDiscount * shipmentData.shipmentCost)/100;
      }else{
        discount = shipmentData.offerValue;
      }
    }
    if(!validate.isEmpty(shipmentData))
    {
      imageUrl = shipmentData.imageIds ? (shipmentData.imageIds.length > 0 ? shipmentData.imageIds[0] : defaultImgUrl ) : defaultImgUrl;
      shipmentName = shipmentData.title;
      city = shipmentData.deliveryCity ? shipmentData.deliveryCity + "," : ""
      deliveryLocation = 'Deliver to '+ city +" "+shipmentData.deliveryCountry;
      priceOffered = shipmentData.itemValue  ;
      shippingCost = shipmentData.shipmentCost;
      actualDiscount = (shippingCost - discount) > 0 ? (shippingCost - discount) : 0
      total = actualDiscount;  // for post an item total should not include item value
    }
    return (
      <div className="shipment-details-section-wrap">
            <div className="shipment-img-wrap">
              <div className="shipment-img" style = {{"backgroundImage": 'url("' + imageUrl + '")' }}></div>
              <div className="shipment-details">
                  <div className="shipment-name">{shipmentName}</div>
                  <div className="shipment-delivery-location">{deliveryLocation}</div>
              </div>
            </div>
            <div className="shipment-price-wrap">
              <div className="shipment-price-description">
                <div className="shipment-price-header">{priceTitle}</div>
                <div className="shipment-price-details">Charged only after acceptance and when delivery is initiated.</div>
              </div>
              <div className="shipment-price">${priceOffered}</div>
            </div>
            <div className="shipment-price-subsection-wrap cf" id="shippingCost">
              <div className="shipment-price-subsection-header f-l">Shipping Cost</div>
              <div className="shipment-price-subsection-cost f-r">${shippingCost}</div>
            </div>
            {
              shipmentData.discount && <div className="shipment-price-subsection-wrap cf" id="shippingCost">
                <div className="shipment-price-subsection-header f-l">Discount {"("+shipmentData.promoCode+")"}</div>
                <div className="shipment-price-subsection-cost f-r">-${discount}</div>
              </div>
            }
            <div className="shipment-price-subsection-wrap cf">
              <div className="shipment-price-subsection-header f-l">Total Cost</div>
              <div className="shipment-price-subsection-cost f-r">${total}</div>
            </div>
      </div>
    )
  }
}


class RequestAnItemWidget extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const shipmentData = this.props.shipmentData || {};
    let imageUrl,shipmentName = "",city = "",deliveryLocation = "",priceOffered = 0,shippingCost =0,total =0;
    let discount = 0 ,actualDiscount=0;
    let priceTitle ;
    if(this.props.for == 1)
      priceTitle = "Item Value"
    else if(this.props.for == 2)
      priceTitle = "PRICE OFFERED"
    let defaultImgUrl = "../../public/images/requester_flow/placeholder.png"
    if(shipmentData.discount){
      if(shipmentData.promoCode == "Referral")
      {
        // discount = shipmentData.percentageDiscount/100;
        discount = (shipmentData.percentageDiscount * shipmentData.shipmentCost)/100;
      }else{
        discount = shipmentData.offerValue;
      }
    }
    if(!validate.isEmpty(shipmentData))
    {
      imageUrl = shipmentData.imageIds ? (shipmentData.imageIds.length > 0 ? shipmentData.imageIds[0] : defaultImgUrl ) : defaultImgUrl;
      shipmentName = shipmentData.title;
      city = shipmentData.deliveryCity ? shipmentData.deliveryCity + "," : ""
      deliveryLocation = 'Deliver to '+ city +" "+shipmentData.deliveryCountry;
      priceOffered = shipmentData.itemValue  ;
      shippingCost = shipmentData.shipmentCost;
      actualDiscount = (shippingCost - discount) > 0 ? (shippingCost - discount) : 0
      total = priceOffered + actualDiscount;
    }
    return (
      <div className="shipment-details-section-wrap">
            <div className="shipment-img-wrap">
              <div className="shipment-img" style = {{"backgroundImage": 'url("' + imageUrl + '")' }}></div>
              <div className="shipment-details">
                  <div className="shipment-name">{shipmentName}</div>
                  <div className="shipment-delivery-location">{deliveryLocation}</div>
              </div>
            </div>
            <div className="shipment-price-wrap">
              <div className="shipment-price-description">
                <div className="shipment-price-header">{priceTitle}</div>
                <div className="shipment-price-details">Charged only after acceptance and when delivery is initiated.</div>
              </div>
              <div className="shipment-price">${priceOffered}</div>
            </div>
            <div className="shipment-price-subsection-wrap cf" id="shippingCost">
              <div className="shipment-price-subsection-header f-l">Shipping Cost</div>
              <div className="shipment-price-subsection-cost f-r">${shippingCost}</div>
            </div>
            {
              shipmentData.discount && <div className="shipment-price-subsection-wrap cf" id="shippingCost">
                <div className="shipment-price-subsection-header f-l">Discount {"( "+shipmentData.promoCode+" )"}</div>
                <div className="shipment-price-subsection-cost f-r">-${discount}</div>
              </div>
            }
            <div className="shipment-price-subsection-wrap cf">
              <div className="shipment-price-subsection-header f-l">Total Cost</div>
              <div className="shipment-price-subsection-cost f-r">${total}</div>
            </div>
      </div>
    )
  }
}

class MakeOfferWidget extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const shipmentData = this.props.shipmentData || {};
    let imageUrl,shipmentName = "",city = "",deliveryLocation = "",priceOffered = 0,shippingCost =0,yourEarn =0;
    let discount = 0 ,actualDiscount=0,awbFee=0,itemValue=0;
    let priceTitle ;
    if(this.props.for == 1)
      priceTitle = "Item Value"
    else if(this.props.for == 2)
      priceTitle = "PRICE OFFERED"
    let defaultImgUrl = "../../public/images/requester_flow/placeholder.png"
    if(shipmentData.discount){
      if(shipmentData.promoCode == "Referral")
      {
        // discount = shipmentData.percentageDiscount/100;
        discount = (shipmentData.percentageDiscount * shipmentData.shipmentCost)/100;
      }else{
        discount = shipmentData.offerValue;
      }
    }
    if(!validate.isEmpty(shipmentData))
    {
      imageUrl = shipmentData ? (shipmentData.thumbnailImage ? shipmentData.thumbnailImage : defaultImgUrl ) : defaultImgUrl;
      shipmentName = shipmentData.title;
      itemValue = shipmentData.itemValue;
      city = shipmentData.deliveryCity ? shipmentData.deliveryCity + "," : ""
      deliveryLocation = 'Deliver to '+ city +" "+shipmentData.deliveryCountry;
      shippingCost = shipmentData.shipmentCost  ;
      awbFee = shipmentData.awbFee;
      if(discount > awbFee)
      {
        discount = awbFee;
      }
      actualDiscount = (awbFee - discount) > 0 ? (awbFee - discount) : 0
      yourEarn = shippingCost - actualDiscount;
      if(shipmentData.shipmentType == 2)
      {  //if the shipement is request an item , your earn will be addition of itemvalue
        yourEarn = yourEarn + itemValue;
        shippingCost = shippingCost + itemValue; // only to display.
      }
    }
    return (
      <div className="shipment-details-section-wrap">
            <div className="shipment-img-wrap">
              <div className="shipment-img" style = {{"backgroundImage": 'url("' + imageUrl + '")' }}></div>
              <div className="shipment-details">
                  <div className="shipment-name">{shipmentName}</div>
                  <div className="shipment-delivery-location">{deliveryLocation}</div>
              </div>
            </div>
            <div className="shipment-price-subsection-wrap cf" id="shippingCost">
              <div className="shipment-price-subsection-header f-l">Total</div>
              <div className="shipment-price-subsection-cost f-r">${shippingCost}</div>
            </div>
            <div className="shipment-price-subsection-wrap cf" id="shippingCost">
              <div className="shipment-price-subsection-header f-l">AWB Fee</div>
              <div className="shipment-price-subsection-cost f-r">-${awbFee}</div>
            </div>
            {
              shipmentData.discount && <div className="shipment-price-subsection-wrap cf" id="shippingCost">
                <div className="shipment-price-subsection-header f-l">Discount {"( "+shipmentData.promoCode+" )"}</div>
                <div className="shipment-price-subsection-cost f-r">-${discount}</div>
              </div>
            }
            <div className="shipment-price-wrap">
              <div className="shipment-price-description">
                <div className="shipment-price-header your-earn">Your Earn</div>
                <div className="shipment-price-details">
                  Your earnings will be the offer price minus the retail price of the item.
                  Your final paymnet will be on hold from the requestor and you will receive the amount upon
                  confirmation of delivery.
                </div>
              </div>
              <div className="shipment-price">${yourEarn} {shipmentData.shipmentType == 2 && <span className = "item-cost">- item cost</span>}</div>
            </div>
            { shipmentData.shipmentType != 2 && <div className="shipment-price-subsection-wrap cf" id="shippingCost">
              <div className="shipment-price-subsection-header f-l">Credit card hold required</div>
              <div className="shipment-price-subsection-cost f-r">${itemValue}</div>
            </div>}
            <div className = "instructions-section">
              If you decide to cancel the offer after a shipper has accepted it, you will be charged 5% of the package's value.
              After carrier has taken your package, cancellation is not allowed.
            </div>
      </div>
    )
  }
}

class Card extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      cardTokenId: props.card.cardTokenId
    }
  }
  getSelectBoxValue = (selectedCardId) => {
    this.setState({"cardTokenId": selectedCardId});
    this.props.updatedSelectedCardId(selectedCardId);
  }

  render(){
    const {props} = this;
    const {card} = this.props;
    const {cardBrand,lastFourDigit,cardHolderName,cardExpMonth,cardExpYear,isDefault,cardTokenId} = card;
    const self = this;
    let radioName = cardBrand+" - "+lastFourDigit;
    const expiry = cardExpMonth + "/" + cardExpYear;

    let radioButtonName = 'card-select';
    let index = props.cardIndex;
    let CheckBoxLabelText = radioName;
    const defaultCardSel = isDefault ? isDefault : false;
    return(
      <div className = "credit-card">
        <div className = "credit-card-data-wrap card-number">
          <div className="radio-button-wrap">
            <div className="radio-button" onClick={this.getSelectBoxValue.bind(self, cardTokenId)} key={index}>
              <input className="checkbox"
                   type="radio"
                   name={radioButtonName}
                   value={this.state.cardTokenId}
                   id={radioButtonName + index}
                   checked = {defaultCardSel} />

              <label className="radio-button-label" htmlFor={radioButtonName + index}></label>
              <label htmlFor={radioButtonName + index} className="radio-button-background"></label>
              <label htmlFor={radioButtonName + index} className="radio-button-name">{CheckBoxLabelText}</label>
            </div>
          </div>
        </div>
        <div className = "credit-card-data-wrap card-holder-name-wrap">
          <div className = "credit-card-data">{cardHolderName}</div>
        </div>
        <div className = "credit-card-data-wrap expiry-wrap">
          <div className = "credit-card-data">{expiry}</div>
        </div>
      </div>
    )
  }
}

class StripePaymentForm extends React.Component{
    constructor(props){
      super(props);
      this.state = {
        cardNumber: '',
        cvv: '',
        expiry: '',
        cardHolderName: '',
        isAgree: false,
        showPaymentWidget: props.showPaymentWidget,
        confirmPaymentIsAgree : false,
        error:""
      }
      this.changeHandler = this.changeHandler.bind(this);
    }

    addNewPayment = (e) => {
      e.preventDefault();
      this.setState({showPaymentWidget: !this.state.showPaymentWidget});
      this.props.setShowPaymentWidget();
      this.clearAllFields();
    }
    clearAllFields = () =>{
      this.setState({
        cardNumber: '',
        cvv: '',
        expiry: '',
        cardHolderName: '',
        isAgree: false
      })
    }
    formatExpiryChange = (val) => {
      if(val && Number(val[0]) > 1){
        val = '0'+val;
      }
      if(val && val.length >1 && Number(val[0]+val[1]) > 12){
        val = '12'+val.substring(2,val.length);
      }
      val = val.substring(0,2)+ (val.length > 2 ? '/'+val.substring(2,4) : '');
      return val;
    }

    changeHandler = (type,e) => {
      let inputVal = e.target.value;
      const stateObj = {};
      if(type==="cvv" && inputVal.length>4) return false;

      stateObj[type] = inputVal;
      this.setState(stateObj);
    }

    getSelectBoxValue = (selectBoxVal) => {
      if(selectBoxVal && selectBoxVal.length>0) this.setState({isAgree: true});
    }

    confirmPaymentCallBack = (selectBoxVal) =>{
      if(selectBoxVal && selectBoxVal.length>0) this.setState({confirmPaymentIsAgree: true});
    }
    back = () =>{
      this.setState({showPaymentWidget: !this.state.showPaymentWidget});
      this.props.setShowPaymentWidget();
    }

    proceedTorRequestanItem = (e) => {
      e.preventDefault();
      if(this.state.confirmPaymentIsAgree)
      {
        this.setState({error : ""})
        this.props.proceedTorRequestanItem();
      }
      else
      {
        this.setState({error : "Please agree to the shipment legal requirements."})
      }
    }

    saveCardData = (e) => {
      e.preventDefault();

      const {state,props} = this;
      const {cardNumber,cvv,expiry,cardHolderName} = state;
      const expiryString = expiry.split("/");
      const expiryMonth = expiryString[0];
      const expiryYear = expiryString[1];

      const cardData = {
        number: cardNumber,
        cvc: cvv,
        exp_month: expiryMonth,
        exp_year: expiryYear,
        name: cardHolderName
      }

      props.createToken(cardData,state.isAgree);
    }

    componentWillReceiveProps(newProps){
      this.setState({showPaymentWidget: newProps.showPaymentWidget})
    }

    render(){
      const {state,props} = this;
      let radioButtonNameArray = ['I verify that my shipment meets all the applicable legal requirements.'];
      let radioButtonName = 'confirm-agreement';
      let confirmPaymentRadioButtonNameArray = ['I verify that my shipment meets all the applicable legal requirements.'];
      let confirmPaymentRadioButtonName = 'confirm-payment';
      const self = this;
      return(
        <div className="payment-section-wrap">
          {state.error && <ShowError errorMessage={state.error}/>}
          <form className="payment">
            <div className="payment-header">Confirm Payment</div>
            {
              props.payment.cards && props.payment.cards.length>0 && !state.showPaymentWidget &&
              <div className = "card-holder-wrap">
               <div className="card-holder-header">Payment Method</div>
                {
                  (props.payment.cards || []).map((card,key) => {
                    return(
                      <Card card={card} key={key} cardIndex={key} updatedSelectedCardId={self.props.updatedSelectedCardId}/>
                    )
                  })
                }
              </div>
            }
            {
              props.payment.cards && props.payment.cards.length ==0 && !state.showPaymentWidget &&
              <div className = "card-holder-header">
                You don't have any cards saved.
              </div>
            }
            {
              !state.showPaymentWidget && props.payment.cards.length > 0 && <div>
              <div id="paymentTerms">If you decide to cancel your shipment after a carrier has accepted it, you will be charged 5% of the package's value. After carrier has taken your package cancellation is not allowed.</div>
              <RadioButton radioButtonName = {confirmPaymentRadioButtonName} radioButtonNameArray={confirmPaymentRadioButtonNameArray} getValueCallback = {this.confirmPaymentCallBack} />
              </div>
            }
            {
              !state.showPaymentWidget && props.payment.cards.length > 0 &&
              <button className="btn orange" id="confirmBtn" onClick = {this.proceedTorRequestanItem}>Confirm Request</button>
            }
            {
              state.showPaymentWidget && <div className="back-section" onClick = {this.back}>
                          <span className="icon-icn_back"></span>
                          <span className = "back-content">Back</span>
                      </div>
            }
            {
              state.showPaymentWidget &&
              <div className = "payment-form-widget">
                <div className = "input-component-wrap">
                  <div className = "title">{"Card Number"}</div>
                  <div className = "input-component">
                    <NumberFormat
                      format="#### #### #### ####"
                      onChange ={this.changeHandler.bind(self,"cardNumber")}
                      value = {state.cardNumber}
                      className ="input"
                      placeholder = "Card number"/>
                  </div>
                </div>
                <div className = "input-component-wrap">
                  <div className = "title">Expiration</div>
                  <div className = "input-component">
                    <NumberFormat
                      format={this.formatExpiryChange}
                      onChange ={this.changeHandler.bind(self,"expiry")}
                      value = {state.expiry}
                      className ="input"
                      placeholder = "MM/YY"/>
                  </div>
                </div>
                <div className = "input-component-wrap">
                  <div className = "title">Security Code</div>
                  <div className = "input-component">
                    <input type="number" name = "cvv" onChange ={this.changeHandler.bind(self,"cvv")} value = {state.cvv} className ="input" placeholder = "CVV" maxLength="4"/>
                  </div>
                </div>
                <div className = "input-component-wrap">
                  <div className = "title">Card holder's name</div>
                  <div className = "input-component">
                    <input type="text"
                           name = "cardHolderName"
                           onChange ={this.changeHandler.bind(self,"cardHolderName")}
                           value = {state.cardHolderName}
                           className ="input"
                           placeholder = "Card holder's name"/>
                  </div>
                </div>
                <div id="paymentTerms">If you decide to cancel your shipment after a carrier has accepted it, you will be charged 5% of the package's value. After carrier has taken your package cancellation is not allowed.</div>
                <RadioButton radioButtonName = {radioButtonName} radioButtonNameArray={radioButtonNameArray} getValueCallback = {this.getSelectBoxValue} />
                <button className="btn orange confirm-btn" onClick = {this.saveCardData}>Submit Card</button>
              </div>
            }
            {
              !state.showPaymentWidget &&
              <button className="btn green" id="confirmBtn" onClick = {this.addNewPayment}>{"Add new payment method"}</button>
            }
          </form>
        </div>
      )
    }
}

class Payment extends React.Component{
  constructor(props){
    super(props);

    this.state = {
      error:'',
      isLoading: false,
      disableSaveBtn: false,
      isLoading: false,
      payment: props.payment,
      defaultCardId : null,
      showPaymentWidget: false
    }
    this.logout = this.logout.bind(this);
  }

  logout() {
    this.props.authActions.logout().always(() => {
        cookies.delete('_sd');
        document.location.href = '/';
    });
  }

  getAllCards = () => {

    const self = this;
    const {paymentActions,authState} = this.props;
    const {userData} = authState;

    this.setState({isLoading: true});
    paymentActions.getAllCards().then(() => {
      this.setState({isLoading: false});

      if(self.props.payment.cards.length > 0) {
        //Add amplitude log
        if(userData.email) amplitude.getInstance().setUserId(userData.email);
        amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.ITEM_CARRY_MAKE_OFFER_CARD_SELECTED);
        this.getDefaultCardId();
      }
      else if(self.props.payment.cards.length===0){
        this.setState({showPaymentWidget: true});
      }
    }, (errorRes) => {
      if(errorRes.error === CONSTANTS.sessionInvalid){
        this.setState({isLoading: false})
        this.props.authActions.sessionValid(false);
        cookies.delete('_sd');
        return ;
      }
      this.setState({
        isLoading: false,
        error: errorRes.error
      })
      $("html, body").animate({scrollTop: 0}, 1000);
    });
  }

  getDefaultCardId = () => {
    const {cards} = this.state.payment;
    let defaultCardId = cards.filter((card,key) => {
      return card.isDefault===true;
    });
    if(defaultCardId && defaultCardId.length>0){
      this.setState({defaultCardId: defaultCardId[0].cardTokenId});
    }
  }

  componentDidMount() {
    Stripe.setPublishableKey(CONSTANTS.STRIPE_KEY);
    this.getAllCards();
  }

  componentWillReceiveProps(newProps){
    if (newProps.payment) this.setState({payment: newProps.payment});
  }

  addCard = (token) => {

    const {userData} = this.props.authState;
    const {paymentActions} = this.props;
    let paramObj = {"stripeToken": token,"makeCardDefault":false};
      this.setState({"isLoading": true});

    paymentActions.addCard(paramObj).then((paramObj) => {

      //Log amplitude event for make an offer payment card added
      if(this.props.paymentFor === 3){
        if(userData.email) amplitude.getInstance().setUserId(userData.email);
        amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.ITEM_CARRY_MAKE_OFFER_CARD_ADDED);
      }

      if(this.props.paymentFor === 1){
        if(userData.email) amplitude.getInstance().setUserId(userData.email);
        amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.POST_ITEM_PAYMENT_ADDED);
      }

      this.setState({showPaymentWidget: false});
      this.getAllCards();
    }, (errorRes) => {
      if(errorRes.error === CONSTANTS.sessionInvalid){
        this.setState({isLoading: false})
        this.props.authActions.sessionValid(false);
        cookies.delete('_sd');
        return ;
      }
      this.setState({
        isLoading: false,
        error: errorRes.error
      })
    });
  }

  createToken = (cardData,isAgree) => {
    this.setState({
      error : ""
    })
    const self = this;
    if(!Stripe.card.validateCardNumber(cardData.number)){
      $("html, body").animate({scrollTop: 0}, 1000);
      return this.setState({"error": "Please enter a valid card number."});
    }
    if(!Stripe.card.validateExpiry(cardData.exp_month,cardData.exp_year)){
      $("html, body").animate({scrollTop: 0}, 1000);
      return this.setState({"error": "Please enter aTesla valid expiration date."});
    }
    if(!Stripe.card.validateCVC(cardData.cvc)){
      $("html, body").animate({scrollTop: 0}, 1000);
      return this.setState({"error": "Please enter a valid CVC code."});
    }
    if(!cardData.name && cardData.name.length===0)
    {
      $("html, body").animate({scrollTop: 0}, 1000);
      return this.setState({"error": "Please enter a valid card holder's name."});
    }
    if(!isAgree)
    {
      $("html, body").animate({scrollTop: 0}, 1000);
      return this.setState({"error": "Please agree to the shipment legal requirements."});
    }

    this.setState({"disableSaveBtn": true , isLoading : true});

    Stripe.card.createToken(cardData, (responseCode, response) => {
      if(responseCode!==200){
        this.setState({"error": response.error.message ,isLoading : false});
         $("html, body").animate({scrollTop: 0}, 1000);
    }
      else{
        const token = response.id;
        this.addCard(token);
        this.setState({
          error : ""
        })
      }
    });
  }

  updatedSelectedCardId = (defaultCardId) => {
    this.setState({defaultCardId})
    let state = Object.assign({},this.state)
    state.payment.cards.map((card, index)=>{
      if(card.cardTokenId == defaultCardId)
        card.isDefault = true
      else
        card.isDefault = false
    })
    this.setState({
      payment : state.payment
    })
  }
  proceedTorRequestanItem = () =>{
      const self = this;
      let parameters ;
      const shipmentDetails = self.props.shipment.shipmentDetails;
      const {userData} = self.props.authState;

      if(!this.state.defaultCardId){
        return this.setState({error: "Please select a card to proceed payment."})
      }

      if(this.props.paymentFor == 2){
        if(userData.email) amplitude.getInstance().setUserId(userData.email);
        amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.REQ_ITEM_PAYMENT_COMPLETE);
      }

      this.setState({error: ""})
      if(this.props.paymentFor == 1)
      {
        parameters = Object.assign({} , this.props.postAShipment);
        parameters.shipmentStatus = 2; //final creation
        parameters.shipmentType = this.props.paymentFor ; //post a shipment
        parameters.stripeId = this.state.defaultCardId;
        let API = "CREATE";
        if(this.props.shipmentId)
          API = "UPDATE"
        this.setState({isLoading: true , error : ""});
        parameters.deliveryDate = localTimestampToGMT(parameters.deliveryDate)
        let value = moment(parameters.deliveryDate)
        if(value.startOf('day').diff(moment().startOf('day') , 'days') == 0)   //check if selected date is today
        {
            parameters.deliveryDate = (new Date(value.unix()*1000).setHours(23,59,59,0))  //store end of the day with 1 minutes less
        }
        this.props.requestAnItemActions.createAshipment(parameters,API).then(() => {

            if(userData.email) amplitude.getInstance().setUserId(userData.email);
            amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.POST_ITEM_COMPLETE);

            this.setState({isLoading: false});
            browserHistory.push('/dashboard/i-am-shipping');
        }, (errorRes) => {
            if(errorRes.error === CONSTANTS.sessionInvalid){
              this.setState({isLoading: false})
              this.props.authActions.sessionValid(false);
              cookies.delete('_sd');
              return ;
            }
            this.setState({isLoading: false,successMsg:"",error:errorRes.error});
        })
      }else if (this.props.paymentFor == 2) {
        parameters = Object.assign({} , this.props.requestAnItem);
        parameters.shipmentStatus = 2; //final creation
        parameters.shipmentType = this.props.paymentFor ; //request an item
        parameters.stripeId = this.state.defaultCardId;
        let API = "CREATE";
        if(this.props.shipmentId)
          API = "UPDATE"
        this.setState({isLoading: true , error : ""});
        parameters.deliveryDate = localTimestampToGMT(parameters.deliveryDate)
        let value = moment(parameters.deliveryDate)
        if(value.startOf('day').diff(moment().startOf('day') , 'days') == 0)   //check if selected date is today
        {
            parameters.deliveryDate = (new Date(value.unix()*1000).setHours(23,59,59,0))  //store end of the day with 1 minutes less
        }
        this.props.requestAnItemActions.createAshipment(parameters,API).then(() => {

            if(userData.email) amplitude.getInstance().setUserId(userData.email);
            amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.REQ_ITEM_COMPLETE);

            this.setState({isLoading: false});
            browserHistory.push('/dashboard/i-am-shipping');
        }, (errorRes) => {
            if(errorRes.error === CONSTANTS.sessionInvalid){
              this.setState({isLoading: false})
              this.props.authActions.sessionValid(false);
              cookies.delete('_sd');
              return ;
            }
            this.setState({isLoading: false,successMsg:"",error:errorRes.error});
        })
      }else if (this.props.paymentFor == 3) {
        parameters = Object.assign({} , this.props.browsePackages.offerData);
        parameters.stripeId = this.state.defaultCardId;
        parameters.carInfo = parameters.car;
        if(parameters.currTransport == "car")
        {
          parameters.carrierTransportType = 2;
        }else if (parameters.currTransport == "flight") {
          parameters.carrierTransportType = 1;
        }else if (parameters.currTransport == "public") {
          parameters.carrierTransportType = 3;
        }
        delete parameters["currTransport"];
        delete parameters["shipperName"]
        delete parameters["isOfferMade"];
        delete parameters["car"];
        delete parameters["public"];
        this.setState({isLoading: true});

        this.props.browsePackagesAction.makeOfferAPI(parameters).then(() => {

          //Request an item
          if(shipmentDetails.shipmentType === 2){
            if(userData.email) amplitude.getInstance().setUserId(userData.email);
            amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.ITEM_REQ_MAKE_OFFER_COMPLETE);
          }
          else{
            if(userData.email) amplitude.getInstance().setUserId(userData.email);
            amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.ITEM_CARRY_MAKE_OFFER_END);
          }

          this.setState({isLoading: false});
          browserHistory.push('/dashboard/i-am-shipping');
        }, (errorRes) => {
            if(errorRes.error === CONSTANTS.sessionInvalid){
              this.setState({isLoading: false})
              this.props.authActions.sessionValid(false);
              cookies.delete('_sd');
              return ;
            }
            this.setState({isLoading: false,successMsg:"",error:errorRes.error});
        })
      }
  }
  setShowPaymentWidget = () => {
    this.setState({showPaymentWidget: !this.state.showPaymentWidget})
  }
  goBack = () =>{
    if(this.props.paymentFor == 1)
    {
      if(this.props.shipmentId)
        browserHistory.push('/post-a-shipment/confirm-details?shipmentId='+ this.props.shipmentId);
      else
        browserHistory.push('/post-a-shipment/confirm-details');
    }else if (this.props.paymentFor == 2) {
      if(this.props.shipmentId)
        browserHistory.push('/request-an-item/confirm-details?shipmentId='+ this.props.shipmentId);
      else
        browserHistory.push('/request-an-item/confirm-details');
    }else if (this.props.paymentFor == 3) {
      if(this.props.shipmentId)
        browserHistory.push('/browse-shipments/paypal-details/' + this.props.shipmentId);
      else
        browserHistory.push('/browse-shipments/paypal-details/');
    }
  }
  render(){
    const {props, state} = this;
    const {userData} = props.authState;
    const {self} = this;

    let user = {
        name: '',
        imageUrl: '',
        isVerified: '',
        creditAmount: ''
    };

    let sessionValid = true ;

    if("sessionValid" in props.authState.userData){
      sessionValid = props.authState.userData.sessionValid;
    }

    if(props.authState) {
      user.name = userData.name;
      user.imageUrl = userData.profileImageUrl;
      user.isVerified = userData.isVerified;
      user.creditAmount = userData.creditAmount
    }
    return(
      <div id="paymentPage">
        <div className="payment-page-wrap">
          <LogoutPopUp isOpen={!sessionValid}></LogoutPopUp>
          {state.error && <ShowError errorMessage={state.error}/>}
          <div className="wrapper">
            <div className="back-section" onClick = {this.goBack}>
                <span className="icon-icn_back"></span>
                <span className = "back-content">Back</span>
            </div>
            <div className = "payment-page">
              {state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
              {
                  this.props.paymentFor == 1  &&
                  <PostAShipmentWidget for = {this.props.paymentFor} shipmentData = {props.shipmentWidgetDetails} />
              }
              {
                this.props.paymentFor == 2 &&
                <RequestAnItemWidget for = {this.props.paymentFor} shipmentData = {props.shipmentWidgetDetails} />
              }
              {
                this.props.paymentFor == 3 && <MakeOfferWidget shipmentData = {props.shipmentWidgetDetails} />
              }
              { state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
              <StripePaymentForm
                authState = {this.props.authState}
                payment={state.payment}
                createToken = {this.createToken}
                disableSaveBtn={state.disableSaveBtn}
                updatedSelectedCardId = {this.updatedSelectedCardId}
                proceedTorRequestanItem = {this.proceedTorRequestanItem}
                showPaymentWidget = {state.showPaymentWidget}
                setShowPaymentWidget = {this.setShowPaymentWidget}
              />
            </div>
          </div>
        </div>
        <LoggedinFooter />
      </div>
    )
  }
}

Payment = connect((state) => {
  return {
    authState: state.app.auth,
    payment: state.app.payment,
    shipment: state.app.shipment,
    requestAnItem : state.app.requestAnItem,
    postAShipment : state.app.postAShipment,
    browsePackages: state.app.browsePackages
  }
}, (dispatch) => {
  return {
    authActions : bindActionCreators(authActions, dispatch),
    paymentActions : bindActionCreators(paymentActions, dispatch),
    requestAnItemActions :bindActionCreators(requestAnItemActions, dispatch),
    browsePackagesAction: bindActionCreators(browsePackagesAction, dispatch)
  }
})(Payment);

export default Payment;



// WEBPACK FOOTER //
// app/payment/payment.jsx